export default __webpack_public_path__ + "images/ab5f68b1e91a572876e23a7c7a5d879f.svg";